import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateInvoicesRequest,
  TCreateInvoicesResponse,
} from "./createInvoice.schema";

/**
 * @description
 * Creates new invoices for a company.
 * Posts to la-forge route: POST /api/invoices
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param params - typed invoices payload
 * @returns created invoices data
 */
export const createInvoices =
  (axios: IAxiosInstance) =>
  async (params: TCreateInvoicesRequest): Promise<TCreateInvoicesResponse> => {
    const response = await axios.noRetry.post("/api/invoices", params);
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error creating invoices");
  };
